<template>
    <div class="admin-logout-modal">
        <div class="header-logout">
            <div class="icon-logout">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path
                        d="M8.75 3.625H3.75V17.375H8.75"
                        stroke="#09090B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path d="M8.75 10.5H17.5" stroke="#09090B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M14.375 7.375L17.5 10.5L14.375 13.625"
                        stroke="#09090B"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <span>Logout Privacy Bee Admin</span>
        </div>
        <div class="content-logout">
            <span>Are you sure you want to logout?</span>
            <span>Logging out will end your current session. Make sure all your work is saved before continuing.</span>
            <div class="actions-div">
                <PrimeButton @click="closeDialog" label="Cancel" variant="secondary" />
                <PrimeButton @click="closeDialog" label="Logout" variant="secondary" class="!bg-red-600 !text-white" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const dialogRef = inject('dialogRef') as any;
const closeDialog = () => {
    dialogRef?.value?.close();
};
</script>
<style lang="scss" scoped>
.admin-logout-modal {
    @apply flex w-[492px] flex-col items-start rounded-lg bg-card-bg shadow-sm;

    .header-logout {
        @apply flex p-6 flex-col justify-center items-center gap-4 self-stretch border-b border-border-gray;

        .icon-logout {
            @apply flex w-12 h-12 justify-center items-center gap-2.5 aspect-square rounded-[28px] bg-zinc-200;
        }

        span {
            @apply text-zinc-950 text-center font-inter text-lg font-bold leading-normal;
        }
    }

    .content-logout {
        @apply flex p-6 flex-col items-center gap-8 self-stretch;
        @apply text-zinc-900 text-center font-inter text-sm font-normal leading-normal;

        .actions-div {
            @apply flex items-start gap-2.5 self-stretch w-full;

            button {
                @apply w-full;
            }
        }
    }
}
</style>
